export function getValidBackUrl(backUrl: string, fallbackUrl: string): string {
  try {
    const url = new URL(backUrl);
    if (url.protocol !== 'https:') {
      return fallbackUrl;
    }
    const hostName = url.hostname;
    return /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)*unext\.(dev|jp)$/.test(
      hostName
    )
      ? url.href
      : fallbackUrl;
  } catch (error) {
    return fallbackUrl;
  }
}
